import { render, staticRenderFns } from "./promosTable.vue?vue&type=template&id=636f3569"
import script from "./promosTable.vue?vue&type=script&lang=js"
export * from "./promosTable.vue?vue&type=script&lang=js"
import style0 from "./promosTable.vue?vue&type=style&index=0&id=636f3569&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports